import styled, { keyframes } from "styled-components";
import { SPACING } from "../../utils/constants";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${SPACING.md + SPACING.xs}px;
  @media (max-width: 600px) {
    padding: ${SPACING.md}px;
  }
`;

export const SpinnerWrapper = styled.div<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border: ${(props) => Math.max(2, props.size / 8)}px solid
    var(--color-border-light);
  border-top: ${(props) => Math.max(2, props.size / 8)}px solid
    ${(props) => props.color || "var(--color-white)"};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
